<!--
 * @Description: 短信模板管理
 * @Version: 1.0
 * @Autor: zhaoyy
 * @Date: 2022-02-14 17:52:53
 * @LastEditors: zhaoyy
 * @LastEditTime: 2022-09-05 19:54:17
-->
<template>
  <div class="sms-template-manage">
    <div class="templat-list" v-if="!showAddPage">
      <div class="search-form">
        <el-form size="small" v-model="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item>
                <el-input
                  v-model="searchForm.templateContent"
                  :maxlength="200"
                  clearable
                  @keyup.enter.native="searchFun"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <el-button type="primary" @click="searchFun">查询</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="4" :offset="10">
              <el-form-item class="add-button">
                <el-button type="primary" @click="newTemplate">新建短信模板</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="table" width="100%" :data="tableList" border stripe size="small" :max-height="newTableHeight">
          <el-table-column label="模板编码" prop="id" width="100"></el-table-column>
          <el-table-column label="模板名称" prop="templateName">
            <template slot-scope="{row}">
              {{row.templateName}}
            </template>
          </el-table-column>
          <el-table-column label="模板类型" prop="templateType">
            <template slot-scope="{ row }">
              <span>{{typeList[row.templateType]}}</span>
            </template>
          </el-table-column>
          <el-table-column label="模板内容" prop="templateContent">
            <template slot-scope="{row}">
              {{row.templateContent}}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime"></el-table-column>
          <el-table-column label="审核状态" prop="verifyStatus">
            <template slot-scope="{ row }">
              <template v-if="row.verifyStatus !== 3">
                <span :class="['point', row.verifyStatus === 1 ? 'warning' : row.verifyStatus === 2 ? 'success' : 'danger']" ></span>
                <span>{{statusList[row.verifyStatus]}}</span>
              </template>
              <template v-else>
                <span :class="['point', 'danger']" ></span>
                <el-tooltip :content="'未通过原因：' + row.rejectDesc" placement="top">
                  <span>{{statusList[row.verifyStatus]}}</span>
                </el-tooltip>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{ row }">
              <el-button type="text" @click="deleteList(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.size"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </div>
    <div class="add-template" v-if="showAddPage">
      <AddSmsTemplate :showAddPage.sync='showAddPage' @commitAdd="searchFun(1)" />
    </div>
  </div>
</template>
<script>
import AddSmsTemplate from './AddSmsTemplate'
import { RESPONSE_SUCCESS } from '@/constants'
import debounce from 'lodash/debounce'
export default {
  name: 'smsTemplateManage',
  components: {
    AddSmsTemplate
  },
  data() {
    return {
      searchForm: {
        templateContent: ''
      },
      tableList: [],
      page: {
        size: 20,
        current: 1,
        total: 0
      },
      showAddPage: false, // 是否新增
      // 状态枚举
      statusList: {
        '1': '待审核',
        '2': '审核通过',
        '3': '审核未通过'
      },
      // 类型枚举
      typeList: {
        '0': '验证码',
        '1': '通知类',
        '2': '营销类'
      },
      newTableHeight: 0,
      tableWidth: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      this.tableWidth = '100%'
    })
    this.searchFun(1)
    this.$nextTick(() => {
      setTimeout(() => {
        this.setTableHeight()
        this.tableWidth = '100%'
        // 绑定窗口resize事件 计算table高度
        this.resizeCallback = debounce(this.setTableHeight, 500)
        window.addEventListener('resize', this.resizeCallback, false)
      }, 300)
    })
  },
  methods: {
    getClientHeight() {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    },
    setTableHeight() {
      const table = this.$refs.table
      if (table) {
        const clientHeight = this.getClientHeight()
        this.newTableHeight = clientHeight - 320
      }
    },
    async searchFun(val) {
      if (val) {
        this.page.current = 1
      }
      const params = {
        ...this.page,
        templateContent: this.searchForm.templateContent
      }
      const { data, msg, code } = await this.$API.smstemplateSearch(params)
      if (code === RESPONSE_SUCCESS) {
        const { records, total, size, current } = data
        this.tableList = records
        this.page.total = total
        this.page.size = size
        this.page.current = current
      } else {
        this.$message.warning(msg)
      }
    },
    // 新增
    newTemplate() {
      this.showAddPage = true
    },
    // 删除
    deleteList(row) {
      this.$confirm(`<h4>此操作将永久删除该文件, 是否继续?</h4>`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(async () => {
          const { code, msg } = await this.$API.smstemplateDel({ id: row.id })
          if (code === RESPONSE_SUCCESS) {
            this.$message.success('删除成功!');
            this.searchFun(1)
          } else {
            this.$message.warning(msg)
          }
        }).catch((err) => {
          console.log(err)
        });
    },
    handleSizeChange(val) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.searchFun()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-input {
  width: 100% !important;
}
.add-button ::v-deep .el-form-item__content {
  text-align: right !important;
}
.table{
  height: calc(100vh - 320px);
}
.page{
  margin-top: 20px;
  text-align: right;
  ::v-deep .el-pagination__editor.el-input {
    width: 50px;
  }
  ::v-deep .el-pagination .el-select .el-input {
    width: 100px;
  }
}
.point::after {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 6px;
  display: inline-block;
  margin-right: 6px;
}
.warning::after {
  background: #E6A23C;
}
.danger::after {
  background: #F56C6C;
}
.success::after {
  background: #67C23A;
}
</style>
